<template>
  <section class="search-container main-content-wrap">
    <div class="search-content">
      <div class="search-top">
        <input v-model="phrase" placeholder="请输入问题关键词，如招商管理" @input="inputHandler" @focus="focusPhrase" @blur="blurPhrase"/>
        <button @click="search()">查询<span></span></button>
        <div class="content" v-if="phrase && isFocus">
          <ul>
            <template v-if="ruleList.length">
              <li v-for="(item, index) in ruleList" :key="index + '-' + item.title">
                <a href="javascript:;" @click.stop="goTo(item)">
                  <span v-html="item.desc"></span>
                </a>
                <!-- <router-link :to="{ name: 'Detail', query: {ruleId: item.ruleId}}">
                  <span v-html="item.desc"></span>
                </router-link> -->
              </li>
            </template>
            <template v-else>
              <li>
                <a href="javascript:;" class="no-content">暂无内容</a>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="search-bottom" v-if="hotWords && hotWords.length">
        热门搜索：
        <span v-for="(item, index) in hotWords" :key="index" @click.stop="search(item.word)">{{item.word}}</span>
      </div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
export default {
  name: '',
  data () {
    return {
      phrase: '',
      pageModal: {
        pageNo: 1,
        pageSize: 15
      },
      ruleList: [],
      isFocus: false
    }
  },
  computed: {
    ...mapState(['hotWords']),
    ...mapState('rule', {
      phraseWatch: 'phrase'
    })
  },
  watch: {
    phraseWatch (newVal, oldVal) {
      this.phrase = newVal
      console.log(222, newVal, oldVal)
    }
  },
  mounted () {
    const {
      phrase
    } = this.$route.query
    console.log('search mounted', phrase, this.$route, this.$router)
    if (phrase) {
      this.phrase = phrase
      console.log('search mounted')
      this.updatePhrase(this.phrase)
    }
    this.getHotKeyWords()
  },
  methods: {
    ...mapMutations('rule', ['updatePhrase']),
    inputHandler (e) {
      // console.log(111, 'inputHandler')
      if (!this.phrase || !this.phrase.trim()) {
        return this.ruleList = []
      }
      this.searchCompletionSuggester({
        phrase: e.target.value
      }).then((resp) => {
        this.ruleList = resp
      })
    },
    blurPhrase () {
      setTimeout(() => {
        this.isFocus = false
      }, 200)
      console.log(111)
    },
    focusPhrase () {
      this.isFocus = true
    },
    goTo (item) {
      console.log('go', this.phrase)
      this.clearRuleList()
      this.$router.push({
        name: item.isNotice ? 'NoticeDetail' : 'Detail',
        query: {
          ruleId: item.ruleId
        }
      })
    },
    clearRuleList () {
      this.phrase = ''
      this.ruleList = []
    },
    ...mapMutations('rule', ['goSearch']),
    ...mapActions({
      getHotKeyWords: 'getHotKeyWords',
      searchCompletionSuggester: 'searchCompletionSuggester'
    }),
    search (phrase = this.phrase) {
      if (!phrase || !phrase.trim()) {
        this.$message.warning({
          content: '请输入要查询的关键字'
        })
        return
      }
      this.$router.push({
        name: 'Search',
        query: {
          phrase: phrase,
          t: Date.now()
        }
      })
      this.goSearch(phrase)
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-container {
    background: url('../assets/img/pic_bg_guizezhongxin.jpg') no-repeat;
    height: 108px;
    color: #fff;
    position: relative;
    z-index: 999;
    .search-content {
      padding-left: 370px;
      padding-top: 24px;
      background: url('../assets/img/pic-rabbit.png') 235px 1px no-repeat;
      background-size: 137px;
      min-height: 84px;
      .search-top {
        background: #FFFFFF;
        border: 2px solid #F10180;
        width: 550px;
        position: relative;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 2px;
        input  {
          width: 454px;
          height: 44px;
          border: none;
          outline: none;
          padding-left: 10px;
          box-sizing: border-box;
          font-size: 14px;
          color: #333;
          vertical-align: top;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 2px;
          overflow: hidden;
        }
        button {
          width: 96px;
          height: 44px;
          text-indent: -999px;
          overflow: hidden;
          background: #F10180;
          border: none;
          position: relative;
          outline: none;
          cursor: pointer;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          span {
            background: url(../assets/img/sprites.png) no-repeat -284px -104px;
            display: block;
            position: absolute;
            width: 20px;
            height: 22px;
            top: 50%;
            left: 50%;
            margin-left: -11px;
            margin-top: -10px;
          }

        }
        .content {
          position: absolute;
          width: 100%;
          top: 100%;
          margin-top: 2px;
          height: auto;
          background-color: #fff;
          border:1px solid #ddd;
          border-top: 0px;
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
          color: #333;
          padding: 8px 0;
          max-height: 296px;
          overflow: auto;
          li {
            line-height: 30px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            a {
              display: block;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 12px;
              font-weight: 700;
              color: #333;
              padding: 0 15px;
              span {
                display: block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              &:hover:not(.no-content) {
                background-color: #f10180;
                color:#fff;
              }
              &.no-content {
                font-weight: 400;
                color:#999;
                cursor: default;
              }
              :deep(em) {
                font-weight: 400;
                font-style: normal;
              }
            }
          }
        }
      }
      .search-bottom {
        margin-top: 7px;
        color: #fff;
        font-size:12px;
        padding-left: 16px;
        span {
          padding: 0 6px;
          cursor: pointer;
          &:hover {
            color:#fff;
          }
        }
      }
    }
  }
</style>
